import { useState } from "react";


export const usePutCrecaAccountStates = () => {
  const [crecaAccountId, setCrecaAccountId] = useState("");
  const [accountSid, setAccountSid] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [isAggregate, setIsAggregate] = useState(false);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    crecaAccountId,
    accountSid,
    selectedStatus,
    isAggregate,
    setCrecaAccountId,
    setAccountSid,
    setSelectedStatus,
    setIsAggregate,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
